export const checkers = {
    joinChannel: (radio, p) => radio.isOn && radio.commMode === p.mode && radio.channel === p.number,
    powerOff: (radio) => radio.hasBeenOn && !radio.isOn,
    exitChannel: (radio) => radio.hasHadChannel && radio.channel === null && radio.commMode === '',
    properShutdown: (radio) => radio.hasHadChannel && radio.hasBeenOn && !radio.isOn && radio.channel === null && radio.commMode === '',
    powerOn: (radio) => radio.isOn,
    changeVolume: (radio) => radio.volume !== 1,

    // Die vier folgenden pruefen den WEG, nicht nur das Ergebnis. Der
    // Zustand allein verraet ihn nicht: ein aus der Liste gewaehlter Kanal
    // sieht aus wie ein getippter, ein Schritt zurueck im Menue hinterlaesst
    // gar nichts, und isTransmitting ist nach dem Loslassen wieder false.
    // Darum die Merkflags auf `radio` (siehe Funkgeraet.vue).
    joinChannelByKeypad: (radio, p) => radio.hasUsedTastatur && radio.commMode === p.mode && radio.channel === p.number,
    joinChannelFromList: (radio, p) => radio.hasUsedListe && radio.commMode === p.mode && radio.channel === p.number,
    menuBack: (radio) => radio.hasGoneBack,
    transmit: (radio) => radio.hasTransmitted
}
